import React from "react";
import "./education.style.sass";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import Header from "../../assets/image/EducationHeader.png";
import { createStructuredSelector } from "reselect";
import { Alert, Icon } from "rsuite";
import Axios from "axios";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import { connect } from "react-redux";
import { selectEducation } from "../../redux/site/site.selector";
import { SetEducation } from "../../redux/site/site.actions";
import { Setting } from "../../setting";

class EducationLayout extends React.Component {
	componentDidMount() {
		const { setEducation } = this.props;

		Axios.get(`${Setting.apiUrl}api/train/list`)
			.then((res) => {
				setEducation(res.data);
			})
			.catch((error) =>
				Alert.error(`برخی از دیتا های سایت لود نمیشود. ${error}`)
			);
	}

	render() {
		const { EducationData } = this.props;

		const HandlePlayOneVid = (index) => {
			const otherVid = [];
			EducationData.map((item, i) => {
				if (i !== index) {
					otherVid.push(i);
				}
			});
			otherVid.map((item) => document.getElementById(`${item}`).pause());
		};

		const override = css`
			display: block;
			margin: 40px auto;
			border-color: red;
			position: relative;
		`;

		return (
			<div>
				<SubHeaderComponent
					imageSrc={Header}
					pageName="آموزش"
				/>
				{EducationData ? (
					<div className="education-page">
						{EducationData.map((item, index) => (
							<div
								className="education-item"
								key={index}
							>
								<div className="education-item-content">
									{item.video.startsWith("storage") ? (
										<video
											id={index}
											onPlay={() => HandlePlayOneVid(index)}
											controls
											className="education-videos"
										>
											<source
												src={
													item.video.startsWith("storage")
														? `${Setting.apiUrl}${item.video}`
														: item.video
												}
												type="video/mp4"
											/>
										</video>
									) : (
										<a href={item.video}>
											<img
												className="education-cover"
												src={`${Setting.apiUrl}${item.cover}`}
												alt={item.name}
											/>
										</a>
									)}

									<div className="education-detail-div">
										<Icon icon="dot-circle-o" /> <span>{item.name}</span>
									</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<div style={{ marginTop: "100px" }}>
						<GridLoader
							css={override}
							size={15}
							margin={8}
							color="#FF8F3C"
						/>
					</div>
				)}
			</div>
		);
	}
}
const mapStateToProps = createStructuredSelector({
	EducationData: selectEducation,
});
const mapDispatchToProps = (dispatch) => ({
	setEducation: (data) => dispatch(SetEducation(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EducationLayout);
